import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const MarketPlaceAPI = createApi({
  reducerPath: 'MarketPlaceAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['MarketPlaceAPI'],
  endpoints: builder => ({
    editConfig: builder.mutation({
      query: ({ id, body }) => ({
        url: `/api/MarketConfig/${id}`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['MarketPlaceAPI'],
    }),
    getMarketConfig: builder.query({
      query: params => ({
        url: `/api/MarketConfig`,
        method: 'GET',
        params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['MarketPlaceAPI'],
    }),
  }),
})

export const { useEditConfigMutation, useGetMarketConfigQuery } = MarketPlaceAPI
